import { Routes } from "@angular/router";
import { permissionType } from "src/app/models/enums";
import { AuthorizationGuard } from "./modules/core/guards/authorization.guard";
import { UnauthorizedComponent } from "./modules/shared/unauthorized/unauthorized.component";
import { NotFoundComponent } from "./modules/shared/not-found/not-found.component";
import { LoginComponent } from "./modules/login/login/login.component";
import { DemoComponent } from "./modules/shared/demo/demo.component";
import { ExpiredComponent } from "./modules/shared/expired/expired.component";
import { ExportsComponent } from "./modules/exports/exports.component";

export const APP_ROUTES: Routes = [
  {
    path: ":guid/admin",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () =>
      import("./modules/admin/admin.routes").then((m) => m.ADMIN_ROUTES),
  },

  {
    path: ":guid/calendar",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () =>
      import("./modules/calendar/calendar.routes").then(
        (m) => m.CALENDAR_ROUTES
      ),
  },

  {
    path: ":guid/dashboard",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () =>
      import("./modules/dashboard/dashboard.routes").then(
        (m) => m.DASHBOARD_ROUTES
      ),
  },

  {
    path: ":guid/notifications",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () =>
      import("./modules/notifications/notifications.routes").then(
        (m) => m.NOTIFICATIONS_ROUTES
      ),
  },

  {
    path: ":guid/shifts",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () =>
      import("./modules/shifts/shifts.routes").then((m) => m.SHIFTS_ROUTES),
  },

  {
    path: ":guid/timeoff-requests",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () =>
      import("./modules/timeoff-requests/timeoff-requests.routes").then(
        (m) => m.TIMEOFF_REQUESTS_ROUTES
      ),
  },

  {
    path: ":guid/scheduler",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () =>
      import("./modules/scheduler/scheduler.routes").then(
        (m) => m.SCHEDULER_ROUTES
      ),
  },

  {
    path: ":guid/timesheets",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () =>
      import("./modules/timesheets/timesheets.routes").then(
        (m) => m.TIMESHEETS_ROUTES
      ),
  },

  {
    path: ":guid/exports",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.AccountManager],
    },
    component: ExportsComponent,
  },

  {
    path: ":guid/demo",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    component: DemoComponent,
  },

  {
    path: ":guid/expired",
    // canActivate: [AuthorizationGuard],
    // data: {
    //   auth: [permissionType.Authenticated],
    // },
    component: ExpiredComponent,
  },

  {
    path: "contact",
    loadChildren: () =>
      import("./modules/contact/contact.routes").then((m) => m.CONTACT_ROUTES),
  },

  {
    path: "register",
    loadChildren: () =>
      import("./modules/register/register.routes").then(
        (m) => m.REGISTER_ROUTES
      ),
  },

  {
    path: "user-accounts",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () =>
      import("./modules/user-accounts/user-accounts.routes").then(
        (m) => m.USER_ACCOUNTS_ROUTES
      ),
  },

  {
    path: ":guid/call-offs",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.AccountManager],
    },
    loadChildren: () =>
      import("./modules/call-offs/call-offs.routes").then(
        (m) => m.CALL_OFFS_ROUTES
      ),
  },

  { path: "login", component: LoginComponent },
  { path: "unauthorized", component: UnauthorizedComponent },
  { path: "notfound", component: NotFoundComponent },
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "**", redirectTo: "/notfound" },
];
